<template>
  <div id="grid-infra">
    <v-flex style="padding: 15px">
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text">Infraestructura</v-toolbar-title>
        <v-btn color="primary" @click="createVisita()" v-if="usuarioLoggedTipe != 'PROVEEDOR'">
          Agregar visita
        </v-btn>
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <!-- <v-layout justify-center>
        <v-flex xs12 md6>
          <v-text-field
            v-model="nombreValue"
            placeholder="Nombre"
            single-line
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaValue"
                label="Fecha de ejecución"
                prepend-icon="event"
                v-on="on"
              ></v-text-field>
            </template>
<v-date-picker v-model="fechaValue" @input="menu1 = false" no-title locale="es" first-day-of-week="1"></v-date-picker>
</v-menu>
</v-flex>
<v-flex xs12 md6>
  <v-select v-model="estadoValue" :items="estadoSelect" item-text="name" item-value="code" label="Estado"></v-select>
</v-flex>

<v-btn fab dark color="teal" title="Filtrar detalle" @click="loadData()">
  <v-icon dark>filter_list</v-icon>
</v-btn>
<v-btn fab dark color="red darken-4" title="Limpiar filtros" @click="clear()">
  <v-icon dark>clear_all</v-icon>
</v-btn>
</v-layout> -->
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table :headers="headers" :items="datosPaginados" :page.sync="page"
              :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" @page-count="pageCount = $event"
              class="elevation-1" hide-actions>
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.titulo }}</td>
                <td class="text-xs-left">{{ props.item.fechaVisita }}</td>
                <td class="text-xs-left">{{ props.item.aprobado }}</td>
                <td>

                  <v-btn depressed outline icon fab dark color="green darken-4" small title="Ver Visita"
                    @click="viewVisita(props.item.id)">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()" depressed outline icon fab dark color="blue darken-4"
                    small title="Duplicar Visita" @click="copyVisita(props.item.id)">
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                  <v-btn v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()" depressed outline icon fab dark color="primary" small
                    title="Editar Visita" @click="editVisita(props.item.id)">
                    <v-icon>open_in_new</v-icon>
                  </v-btn>

                  <v-btn v-if="props.item.firmado && 'Aprobada' == props.item.aprobado" depressed outline icon fab dark
                    color="secondary" title="Descargar PDF" small @click="descargarDocumento(props.item.id)">
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                  <v-btn v-if="!props.item.firmado && 'Aprobada' == props.item.aprobado" depressed outline icon fab dark
                    color="info" title="Firmar Visita" small @click="firmarDocumento(props.item.id)">
                    <v-icon>verified_user</v-icon>
                  </v-btn>

                </td>
              </template>
            </v-data-table>
            <v-flex xs12 sm6>
              <v-text-field value="" label="Total de Registros" v-model="cantRegistros" disabled></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination @input="changePage(page)" v-model="page" :length="pageCount" :total-visible="9" circle>
              </v-pagination>
            </div>
          </template>
          <!-- LEYENDA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn class="btn-sigas" depressed outline icon fab dark color="green darken-4" small>
              <v-icon>remove_red_eye</v-icon> </v-btn>&nbsp;Ver Visita
            <v-btn v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()" depressed outline icon fab dark color="blue darken-4" small
              title="Duplicar Visita">
              <v-icon>content_copy</v-icon> </v-btn>&nbsp;Duplicar Visita
            <v-btn v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()" depressed outline icon fab dark color="primary" small
              title="Editar Visita">
              <v-icon>open_in_new</v-icon> </v-btn>&nbsp;Editar Visita
          </v-card-actions>
        </v-flex>
      </v-layout>

      <!-- Diálogo para confirmar la firma del documento -->
      <v-dialog v-model="confirmFirmaDialog" max-width="500">
        <v-card>
          <v-card-title class="headline" style="font-weight: bold">
            Confirmación de Firma
          </v-card-title>
          <v-card-text>
            ¿Está seguro que desea firmar el documento?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="cancelConfirmFirma">
              Cancelar
            </v-btn>
            <v-btn color="indigo darken-1" flat @click="confirmarFirma">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import jwtDecode from "jwt-decode";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "grid-infra",

  components: {
    AlertEmpty,
    Loading,
  },
  mixins: [misMixins],
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      confirmFirmaDialog: false,
      idVisitaFirmaConfirmation: null,
      loading: false,
      alerta: false,
      id: "",
      idContrato: "",
      usuarioLoggedTipe: "",
      headers: [
        { text: "Nombre", align: "left", sortable: false, value: "nombre" },
        { text: "Fecha ejecución", sortable: false, value: "fechaEjecución" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Acción", sortable: false, value: "" },
      ],
      itemsInfra: [],
      nombreValue: null,
      estadoSelect: [],
      estadoValue: null,
      fechaValue: null,
      menu1: false,

      //paginacion
      rowsPerPageItems: [20],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,

      periodo: 0,
    };
  },
  watch: {},

  created() {
    // console.log("infraestructura");
    this.idContrato = this.$store.getters.contratoStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    this.loadData();
  },
  mounted() { },
  computed: {},
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    async loadInfra() {
      return await axios
        .get("/validaciones/getVisitas/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      this.itemsInfra = await this.loadInfra();
      this.loading = false;

      if (this.itemsInfra.length > 0) {
        this.cantRegistros = this.itemsInfra.length; // dsoto 10-11-2022
        this.pageCount = Math.ceil(
          this.itemsInfra.length / this.rowsPerPageItems
        ); // dsoto 09-11-2022
        this.getDataPagina(this.page); // dsoto 09-11-2022

        this.loadEstado();
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
    },
    loadEstado() {
      let est = [];
      this.itemsInfra.forEach(function (c) {
        let index = est.findIndex((x) => x.name == c.nombre);
        if (index === -1 && c.nombre != null && c.nombre != "") {
          est.push({ name: c.nombre, code: c.id });
        }
      });
      this.estadoSelect = est;
    },
    clear() {
      this.estadoValue = null;
      this.nombreValue = null;
      this.fechaValue = null;
      this.loadData();
    },

    // paginacion
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },

    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsInfra.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;
      this.datosPaginados = this.itemsInfra.slice(0, this.itemsInfra.length);
    },

    viewVisita(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "InfraestructuraData",
          query: {
            idVisita: id,
            tipeView: "consulta",
          },
        });
      }, 1000);
    },
    copyVisita(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "InfraestructuraData",
          query: {
            idVisita: id,
            tipeView: "copiar",
          },
        });
      }, 1000);
    },
    createVisita() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "InfraestructuraData",
          query: {
            idVisita: -1,
            tipeView: "crear",
          },
        });
      }, 1000);
    },
    editVisita(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "InfraestructuraData",
          query: {
            idVisita: id,
            tipeView: "crear",
          },
        });
      }, 1000);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
      }, 1000);
    },
    firmarDocumento(idVisita) {
      this.idVisitaFirmaConfirmation = idVisita;
      this.confirmFirmaDialog = true;
    },

    // Se ejecuta al confirmar la firma en el diálogo
    confirmarFirma() {
      // Obtén los datos del usuario autenticado desde el store

      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = decoded.dto;


          const payload = {
            idVisita: this.idVisitaFirmaConfirmation,
            rutProveedor: user.username,
            nombreProveedor: user.nombre + " " + user.apellido,
            idUsuario: user.id // Si lo necesitas para relacionar en la tabla
          };

          axios
            .post("/firmarDocumentoPDF", payload)
            .then((response) => {
              
              this.$emit("APP_SAVE");
              // Cierra el diálogo y reinicia la variable de confirmación
              this.loadData();
              this.confirmFirmaDialog = false;
              this.idVisitaFirmaConfirmation = null;
            })
            .catch((error) => {
              console.error("Error al firmar el documento:", error);
              this.$emit(
                "ERROR_EXCEPTION",
                (error.response && error.response.data && error.response.data.message) ||
                "Error al firmar el documento"
              );
              this.confirmFirmaDialog = false;
              this.idVisitaFirmaConfirmation = null;
            });
        } catch (error) {
          console.error("Error decodificando el token:", error);
          this.$store.dispatch("logout");
        }
      }
    },

    // Cancela la acción de firma
    cancelConfirmFirma() {
      this.confirmFirmaDialog = false;
      this.idVisitaFirmaConfirmation = null;
    },

    descargarDocumento(idVisita) {
      axios.get(`/obtener_firma/${idVisita}`, { responseType: "json" })
        .then(response => {
          const base64String = response.data.documentoFirmado;
          const dataUrl = "data:application/pdf;base64," + base64String;
          const link = document.createElement("a");
          link.href = dataUrl;
          link.setAttribute("download", "visita_firmada.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(error => {
          console.error("Error al descargar el documento firmado", error);
        });
    }


  },
};
</script>